import { Injectable, signal } from '@angular/core';

export type TaskNotificationStatus = 'running' | 'success' | 'error';

export interface TaskNotificationItem {
  id: string;
  title: string;
  message: string;
  status: TaskNotificationStatus;
}

@Injectable({ providedIn: 'root' })
export class TaskNotificationService {
  tasks = signal<TaskNotificationItem[]>([]);

  start(title: string, message: string): string {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    this.tasks.update(tasks => [...tasks, { id, title, message, status: 'running' }]);
    return id;
  }

  succeed(id: string, message: string, title?: string): void {
    this.update(id, 'success', message, title);
    this.scheduleDismiss(id);
  }

  fail(id: string, message: string, title?: string): void {
    this.update(id, 'error', message, title);
    this.scheduleDismiss(id, 7000);
  }

  dismiss(id: string): void {
    this.tasks.update(tasks => tasks.filter(task => task.id !== id));
  }

  private update(id: string, status: TaskNotificationStatus, message: string, title?: string): void {
    this.tasks.update(tasks => tasks.map(task =>
      task.id === id
        ? { ...task, status, message, title: title ?? task.title }
        : task
    ));
  }

  private scheduleDismiss(id: string, delayMs: number = 3500): void {
    window.setTimeout(() => this.dismiss(id), delayMs);
  }
}
